<template>
  <section>
    <div class="settings-header">
      {{ __('Origens Customizadas') }}
      <button
        class="btn btn-primary ml-auto"
        @click.prevent="create()"
      >
        {{ __('Adicionar origem') }}
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="form-text">
          {{ __('Defina origens customizadas, elas aparecerão como opção no cadastramento do lead.') }}
        </p>
        <div class="row">
          <div
            class="col-12"
            v-if="status.loading"
          >
            <i class="fa fa-circle-o-notch fa-spin mt-4" />
          </div>
          <div
            class="col-12"
            v-else
          >
            <ul class="settings-group list-group mt-4">
              <li
                class="list-group-item d-flex align-items-center"
                v-for="start in origins"
                :key="start.id"
              >
                <span class="mr-3">{{ start.name }}</span><a
                  class="ml-auto mt-n1px"
                  href="#"
                  v-b-tooltip.left="__('Editar origem')"
                  @click.prevent="edit(start)"
                >
                  <IconPencilFilled :size="18" /></a><a
                  class="ml-3 mt-n1px"
                  href="#"
                  v-b-tooltip.left="__('Excluir origem')"
                  @click.prevent="destroy(start)"
                  v-if="! start.has_parent"
                >
                  <IconTrash :size="18" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <BModal
      id="custom-origin-modal"
      ref="custom-origin-modal"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div
          class="modal-title"
          v-if="origin.id"
        >
          {{ __('Editar origem') }}
        </div>
        <div
          class="modal-title"
          v-else
        >
          {{ __('Nova origem') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form @submit.prevent="save">
          <div class="form-group">
            <label for="field-description">{{ __('Nome') }}</label>
            <input
              class="form-control"
              type="text"
              v-model="origin.name"
              :placeholder="__('Nome da origem')"
            >
          </div>
          <BFormCheckbox
            v-model="origin.hidden"
          >
            {{ __('Não exibir esta origem no cadastro do lead') }}
          </BFormCheckbox>
          <div class="d-flex flex-column modal-footer default-modal-footer p-0 mt-3">
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="status.saving"
            >
              <span v-if="status.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
            <button @click="close" type="button" class="btn pb-0">
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </section>
</template>

<script>
import { BModal, VBTooltip, BFormCheckbox } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
    BFormCheckbox,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      status: {
        saving: false,
        loading: true,
      },
      origin: {},
      origins: [],
    };
  },

  created () {
    this.fetch();
  },

  methods: {
    fetch () {
      this.$http.get('/settings/origin')
        .then(({ data }) => this.origins = data.map((origin) => {
          origin.has_parent = Object.entries(origin).some(([key, value]) => key.endsWith('_count') && value > 0);

          return origin;
        }))
        .then(() => this.status.loading = false)
        .catch(() => console.error(this.__('Erro ao listar origens')));
    },

    create () {
      this.origin = {};
      this.open();
    },

    edit (origin) {
      this.origin = { ...origin };
      this.open();
    },

    save () {
      this.status.saving = true;

      this.createOrUpdate(this.origin)
        .then(() => {
          this.close();

          this.status.saving = false;

          this.fetch();

          Bus.$emit('createOrUpdateOrigin');
        });
    },

    createOrUpdate (origin) {
      if (origin.id) {
        return this.$http.put(`/settings/origin/${origin.id}`, origin)
          .then(() => Alert.success(this.__('Origem atualizada com sucesso.')))
          .catch(() => {
            Alert.error(this.__('Erro ao atualizar origem.'));

            this.status.saving = false;
          });
      }

      return this.$http.post('/settings/origin', origin)
        .then(() => Alert.success(this.__('Origem criada com sucesso.')))
        .catch(() => {
          Alert.error(this.__('Erro ao criar origem.'));

          this.status.saving = false;
        });
    },

    async destroy (origin) {
      if (! await Confirm(this.__('Deseja excluir esta origem?'))) {
        return;
      }

      this.$http.delete(`/settings/origin/${origin.id}`)
        .catch(() => {
          Alert.error(this.__('Não foi possível excluír a origem.'));
        }).then(() => {
          this.origins.splice(this.origins.indexOf(origin), 1);

          Alert.info(this.__('Origem excluída.'));
        });
    },

    close () {
      this.$refs['custom-origin-modal'].hide();
    },

    open () {
      this.$refs['custom-origin-modal'].show();
    },
  },
};
</script>

<style scoped>
.btn-cancel {
  font-size: 11px;
}

::v-deep div > input[type='checkbox'] + *::before {
  border: 1.6px solid gray;
}
</style>
